<template>
  <div
    data-component-group="form"
    data-component="edit-user"
    class="elevation-1"
  >
    <CommentForm
      :comment="comment"
      confirm-trigger-label="Update comment"
      :is-disabled="!canEditDetails"
      :is-loading="isLoading"
      :on-submit="onSubmit"
    >
      <template v-slot:beforeForm>
        <layout-section-header
          title="Details"
          :has-trigger="hasTrigger"
          :trigger-label="triggerLabel"
          @toggle="toggleEditDetails"
        />
      </template>
    </CommentForm>
  </div>
</template>

<script>
  import CommentForm from './AddNew';

  export default {
    components: {
      CommentForm,
    },
    props: {
      comment: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        canEditDetails: false,
      };
    },
    computed: {
      triggerLabel() {
        return this.canEditDetails ? 'Close' : 'Edit details';
      },
      hasTrigger() {
        return this.$store.getters['auth/isAuthorized']([{ subject: 'comment', actions: ['update'] }]);
      },
    },
    watch: {
      comment() {
        this.canEditDetails = false;
      },
    },
    methods: {
      toggleEditDetails() {
        this.canEditDetails = !this.canEditDetails;
      },
    },
  };
</script>
